import Cover from "./BookCover";

export default function BookCard({ book, onView, cart, addCart, compact = false }) {
    const inCart = cart.some(c => c._id === book._id);

    const disc = b => Math.round((1 - b.price / b.orig) * 100);

    const d = disc(book);
    return (
        <div className="book-card-wrap" onClick={() => onView(book)} style={{
            background: "var(--paper)", borderRadius: 18, border: "1.5px solid var(--border)",
            overflow: "hidden", cursor: "pointer", display: "flex", flexDirection: "column",
            width: compact ? "180px" : "220px",
            minWidth: compact ? "180px" : "220px",
            height: compact ? "300px" : "320px",
            flexShrink: 0
        }}>
            <div style={{ background: `linear-gradient(180deg,${book.color}18 0%,${book.color}08 100%)`, padding: "24px 18px 16px", display: "flex", justifyContent: "center", position: "relative" }}>
                <Cover book={book} w={compact ? 100 : 130} h={compact ? 140 : 182} />
                {book.badge && <div style={{ position: "absolute", top: 10, right: 10, background: book.badge === "Bestseller" ? "var(--terra)" : book.badge === "New" ? "var(--forest)" : book.badge === "Advanced" ? "var(--rose)" : "var(--gold)", color: "white", fontSize: 10, fontWeight: 800, padding: "3px 9px", borderRadius: 50, animation: "badgePop 0.4s 0.2s both", letterSpacing: "0.05em" }}>{book.badge}</div>}
                {d > 0 && <div style={{ position: "absolute", top: 10, left: 10, background: "var(--cream)", color: "var(--terra)", fontSize: 10, fontWeight: 800, padding: "3px 8px", borderRadius: 50, border: "1.5px solid var(--terra)" }}>{d}% OFF</div>}
            </div>
            <div style={{ padding: compact ? "12px 14px 16px" : "14px 16px 18px", flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
                <div style={{
                    fontSize: compact ? 12 : 13,
                    fontWeight: 700,
                    fontFamily: "'Playfair Display',serif",
                    lineHeight: 1.3,
                    color: "var(--ink)",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    minHeight: "2.6em" /* Height for 2 lines */
                }}>
                    {book.title}
                </div>
                {!compact && <div style={{ fontSize: 11, color: "var(--text3)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{book.author}</div>}
                {/* <div style={{ fontSize: 11, color: "var(--gold)", letterSpacing: "0.05em" }}>{stars(book.rating)} <span style={{ color: "var(--text3)", fontFamily: "'Nunito Sans',sans-serif" }}>({book.reviews.toLocaleString()})</span></div> */}
                {/* <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
                    <span style={{ fontFamily: "'Playfair Display',serif", fontSize: compact ? 15 : 17, fontWeight: 800, color: "var(--forest)" }}>{fmtINR(book.price)}</span>
                    <span style={{ fontSize: 11, color: "var(--text4)", textDecoration: "line-through" }}>{fmtINR(book.orig)}</span>
                </div> */}
                {/* <button onClick={e => { e.stopPropagation(); addCart(book); }} className="btn" style={{
                    marginTop: 6, width: "100%", justifyContent: "center",
                    padding: compact ? "8px" : "10px 14px",
                    background: inCart ? "var(--forest2)" : "var(--forest)",
                    color: "white", borderRadius: 10, fontSize: 12, fontWeight: 700,
                    transition: "all 0.2s",
                }}>
                    {inCart ? "✓ In Cart" : "Add to Cart"}
                </button> */}
            </div>
        </div>
    );
}
